const addInterfacePage = () => import('@/views/main/base/add-Interface/add-Interface.vue')
export default {
  path: '/main/shop/addInterfacePage',
  name: 'addInterfacePage',
  component: addInterfacePage,
  children: []
}
